import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Button, CardText, Col, Form, Row, Spinner } from "reactstrap";
import coverImg from "../assets/pages/Temple.jpeg";
import personImg from "../assets/icons/account.svg";
import emailImg from "../assets/icons/email.svg";
import calendarImg from "../assets/icons/calendar.svg";
import logo from "../assets/logo/main-logo.png";
import "../common.scss";
import { Formik } from "formik";
import CustomCountryMobileField from "../views/common/customCountryMobileField";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { DatePicker, Input } from "antd";
import momentGenerateConfig from "rc-picker/lib/generate/moment";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getTrustDetail, loginPage } from "../utility/commonApi";
import { setTrustData } from "../redux/slices/authSlice";
import placeholderImg from "../assets/pages/placeholder.png";
import * as Yup from "yup"; // Import Yup for validation
import { fetchImage } from "../utility/commonDownloadS3Image";
const CustomDatePickerComponent =
  DatePicker.generatePicker(momentGenerateConfig);

const Login = () => {
  const navigate = useNavigate();
  const trustId = localStorage.getItem("trustId");

  const userDetails = useSelector((state) => state.auth);
  const trustData = userDetails && userDetails?.trustData;
  const location = useLocation();

  const hostname = window.location.host;
  const dispatch = useDispatch();
  const subdomainChange = process.env.REACT_APP_ADMIN_SUBDOMAIN_REPLACE_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_URL;

  const [mobileNumber, setMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");

  const handlePhoneChange = ({ countryCode, mobileNumber }) => {
    const sanitizedNumber = mobileNumber.replace(/\D/g, "").trim();
    setMobileNumber(sanitizedNumber);

    setCountryCode(`+${countryCode}`);
  };
  const handleMobileChange = ({ countryCode, mobileNumber }, setFieldValue) => {
    const sanitizedNumber = mobileNumber.replace(/\D/g, "").trim();
    setFieldValue("mobileNumber", sanitizedNumber);
    setCountryCode(`+${countryCode}`);
  };

  const [otp, setOtp] = useState("");
  const onChange = (text) => {
    // console.log("onChange:", text);
    setOtp(text);
  };
  const onInput = (value) => {
    // console.log("onInput:", value);
  };
  const sharedProps = {
    onChange,
    onInput,
  };

  const [step, setStep] = useState("login"); // track current step (login or signup)
  const { sendOTP, verifyOTP, isLoading, registerUser } = useAuth();
  const SignupSchema = Yup.object().shape({
    name: Yup.string().required("Full Name is required."),
    mobileNumber: Yup.string().required("Mobile number is required."),
    email: Yup.string()
      .email("Invalid email address."),
  });
  //   const validateMobileNumber = (number) => {
  //     const phoneRegex = /^[6-9]\d{9}$/;
  //     return phoneRegex.test(number);
  //   };

  const handleSendOTP = async (e) => {
    e.preventDefault();
    try {
      const success = await sendOTP(mobileNumber, countryCode);
      if (success) {
        setStep("otp"); // Move to OTP step
        toast.success("OTP sent successfully!");
      }
    } catch (error) {
      if (error.message.includes("This number does not exist")) {
        setStep("not_exist_cta");
      } else {
        toast.error(error.message || "Failed to send OTP");
      }
    }
  };
  const { from } = location.state || { from: "/" };
  const sevaRecord = location.state?.sevaRecord;

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (otp.length !== 6) {
      toast.error("Please enter a 6-digit OTP");
      return;
    }

    try {
      const success = await verifyOTP(mobileNumber, otp);
      if (success) {
        toast.success("Login successful!");
        navigate(from, { replace: true, state: sevaRecord });
      }
    } catch (error) {
      toast.error("Failed to verify OTP");
    }
  };

  const handleSignup = async (e, values, resetForm) => {
    e.preventDefault();

    const payload = { ...values, countryCode: countryCode };
    if (!payload.email || payload.email.trim() === "") {
      payload.email = `Support+${values.mobileNumber}@apnadharm.com`;
    }
    
    try {
      const success = await registerUser(payload);
      if (success) {
        setStep("login"); // After signup, move to OTP step
        resetForm();
        toast.success("Signup successful! Please verify OTP.");
      } else {
        toast.error("Failed to sign up");
      }
    } catch (error) {
      toast.error("Failed to sign up");
    }
  };

  let subDomainName;
  if (hostname !== adminUrl) {
    subDomainName = hostname.replace(subdomainChange, "");
  } else {
    subDomainName = hostname.replace(
      process.env.REACT_APP_GENERIC_ADMIN_SUBDOMAIN_REPLACE_URL,
      ""
    );
  }
  const tId = trustId ?? trustData?.id;

  const loginPageQuery = useQuery({
    queryKey: [subDomainName],
    queryFn: () => loginPage(subDomainName),
    enabled: !!subDomainName, // Only run query if subdomain exists
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  const loginPageData = useMemo(() => {
    const result = loginPageQuery?.data?.data?.result;
    return result;
  }, [loginPageQuery?.data, dispatch]);

  const [imageUrl, setImageUrl] = useState(null);
  // For login cover image loading
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    // Ensure trustData is set from loginPageData if not in Redux
    if (loginPageData && !trustData) {
      dispatch(setTrustData(loginPageData));
    }
  }, [loginPageData, trustData, dispatch]);

  useEffect(() => {
    if (trustData) {
      const loadImages = async () => {
        const url = await fetchImage(
          trustData.trustLogo ? `${trustData.trustLogo["name"]}` : null
        );
        setImageUrl(url);
      };

      loadImages();
    }
  }, [trustData]);
  return (
    <div className="loginwrapper auth-wrapper auth-cover">
      <Row className="auth-inner m-0 defaultFontColor">
        <Col
          className="d-none d-lg-flex pe-0 ps-0 align-items-center h-100"
          lg="7"
          sm="12"
        >
          <div className="w-100 h-100 d-lg-flex align-items-center justify-content-center loginBackground" style={{ position: 'relative' }}>
            {/* Image loader/fade-in logic */}
            { !imgLoaded && (
              <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: '#f5f5f5', zIndex: 1
              }}>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </div>
            )}
            <img
              className={`img-fluid w-100${imgLoaded ? ' h-100 fade-in' : ''}`}
              src={loginPageData && loginPageData.profilePhoto && loginPageData.profilePhoto !== "" ? loginPageData.profilePhoto : placeholderImg}
              alt="Login Cover"
              style={{ opacity: imgLoaded ? 1 : 0, transition: 'opacity 0.5s' }}
              onLoad={() => setImgLoaded(true)}
              onError={() => setImgLoaded(true)}
            />
          </div>
        </Col>
        <Col
          className="d-flex justify-content-center align-items-center h-100 auth-bg p-5"
          lg="5"
          sm="12"
          style={{ backgroundColor: "#FFF" }}
        >
          <Col
            className="px-xl-2 mx-auto"
            xs="12"
            sm="8"
            md="8"
            lg="9"
            style={{
              backgroundColor: "#FCF5E7",
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              className="logo-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={
                  ((imageUrl && imageUrl) ||
                    (trustData && trustData?.trustLogo?.presignedUrl)) ??
                  logo
                }
                alt="Logo"
                style={{
                  maxWidth: "200px",
                  height: "auto",
                  marginLeft: "0",
                  marginRight: "0",
                  marginBottom: "20px",
                }}
              />
            </div>

            <CardText className="signInEnterUserName">
              {(trustData && trustData?.name) ? `${trustData.name} Welcomes You` : ""}
            </CardText>

            {step === "login" && (
              <>
                <CardText className="signInEnterMobile">
                  Enter Your Mobile Number
                </CardText>
                <Formik initialValues={{ mobileNumber: "" }}>
                  {(formik) => (
                    <Form className="auth-login-form mt-3 mx-3">
                      <div className="mb-1 d-flex justify-content-center flex-column align-items-center">
                        <div className="mb-5 w-100">
                          <CustomCountryMobileField
                            value={{ mobileNumber, countryCode: countryCode.replace('+', '') }}
                            placeholder="Enter your mobile number"
                            required
                            onChange={handlePhoneChange}
                          />
                        </div>
                        <div className="otpBtn">
                          <Button
                            color="primary"
                            className="addAction-btn"
                            onClick={handleSendOTP}
                            disabled={!mobileNumber || isLoading}
                          >
                            {isLoading ? <Spinner size="sm" /> : "Send OTP"}
                          </Button>
                          <div className="otherOption mt-2">
                            <span>Don't have an account? </span>
                            <span
                              className="signUpText"
                              onClick={() => setStep("signup")}
                            >
                              Sign up.
                            </span>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </>
            )}

            {step === "signup" && (
              <>
                <Formik
                  initialValues={{
                    name: "",
                    mobileNumber: mobileNumber || "",
                    email: "",
                    dob: "",
                  }}
                  validationSchema={SignupSchema}
                >
                  {({
                    values,
                    handleBlur,
                    errors,
                    touched,
                    isSubmitting,
                    setFieldValue,
                    isValid,
                    dirty,
                    resetForm,
                  }) => (
                    <Form className="auth-login-form mt-3 mx-3">
                      <div className="mb-1 d-flex justify-content-center flex-column align-items-center">
                        <div className="mb-5 w-100">
                          <div className="mb-2">
                            <label>
                              Full Name<span className="text-danger">*</span>
                            </label>
                            <Input
                              type="text"
                              placeholder="Full Name"
                              value={values.name}
                              onChange={(e) =>
                                setFieldValue("name", e.target.value)
                              }
                              onBlur={handleBlur}
                              className="inputBox"
                              name="name"
                              prefix={
                                <img
                                  src={personImg}
                                  alt="person-icon"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                  }}
                                />
                              }
                            />
                            <div className="errorMessage text-primary">
                              {touched.name && errors.name && (
                                <span className="text-danger">
                                  {errors.name}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="mb-2">
                            <label>
                              Mobile No<span className="text-danger">*</span>
                            </label>
                            <CustomCountryMobileField
                              name="mobileNumber"
                              value={{ mobileNumber: values.mobileNumber, countryCode: countryCode.replace('+', '') }}
                              placeholder="Enter your mobile number"
                              onChange={(data) =>
                                handleMobileChange(data, setFieldValue)
                              }
                              onBlur={() =>
                                handleBlur({ target: { name: "mobileNumber" } })
                              }
                              error={errors.mobileNumber}
                              touched={touched.mobileNumber}
                            />
                          </div>
                          <div className="mb-2">
                            <label>
                              Email
                            </label>
                            <Input
                              type="email"
                              placeholder="Email"
                              value={values.email}
                              onChange={(e) =>
                                setFieldValue("email", e.target.value)
                              }
                              onBlur={handleBlur}
                              className="inputBox"
                              name="email"
                              prefix={
                                <img
                                  src={emailImg}
                                  alt="person-icon"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                  }}
                                />
                              }
                            />
                            <div className="errorMessage text-primary">
                              {touched.email && errors.email && (
                                <span className="text-danger">
                                  {errors.email}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="mb-2 d-flex flex-column">
                            <label>Date of birth</label>
                            <CustomDatePickerComponent
                              value={values.dob}
                              format="DD MMM YYYY"
                              onChange={(date) => setFieldValue("dob", date)}
                              className="inputBox"
                              placeholder="Date of Birth"
                              name="dob"
                              prefix={
                                <img
                                  src={calendarImg} // Use your custom image
                                  alt="calendar-icon"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                  }}
                                />
                              }
                              disabledDate={(current) =>
                                current &&
                                (current.isSame(moment(), "day") ||
                                  current.isAfter(moment()))
                              }
                            />
                          </div>
                        </div>
                        <div className="otpBtn">
                          <Button
                            color="primary"
                            className="addAction-btn"
                            // disabled={isLoading}
                            disabled={!isValid || !dirty}
                            onClick={(e) => handleSignup(e, values, resetForm)}
                          >
                            {isLoading ? <Spinner size="sm" /> : "Sign Up"}
                          </Button>
                          <div className="otherOption mt-2">
                            <span>Already have an account? </span>
                            <span
                              className="signUpText"
                              onClick={() => setStep("login")}
                            >
                              Login.
                            </span>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </>
            )}

            {step === "not_exist_cta" && (
              <div className="text-center py-4">
                <div 
                  className="mb-3 d-inline-flex justify-content-center align-items-center"
                  style={{ width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#fff3e0', color: '#e27129' }}
                >
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <line x1="19" y1="8" x2="19" y2="14"></line>
                    <line x1="22" y1="11" x2="16" y2="11"></line>
                  </svg>
                </div>
                <h4 className="mb-2" style={{ fontWeight: '600', color: '#333' }}>Welcome!</h4>
                <CardText className="text-muted mb-4" style={{ fontSize: '15px' }}>
                  It looks like you're new here. Let's create an account for <span style={{ fontWeight: 'bold', color: '#000' }}>{countryCode} {mobileNumber}</span> so you can get started!
                </CardText>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  <Button
                    color="secondary"
                    outline
                    className="px-4 py-2"
                    style={{ borderRadius: '8px', fontWeight: '500' }}
                    onClick={() => setStep("login")}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    className="px-4 py-2"
                    style={{ borderRadius: '8px', fontWeight: '500', backgroundColor: '#e27129', border: 'none' }}
                    onClick={() => setStep("signup")}
                  >
                    Sign Up Now
                  </Button>
                </div>
              </div>
            )}

            {step === "otp" && (
              <>
                <CardText className="signInEnterMobile">
                  We have sent OTP on your mobile number
                </CardText>
                <div className="w-100 d-flex justify-content-center align-items-center mb-5">
                  <Input.OTP
                    formatter={(str) => str.toUpperCase()}
                    maxLength={6}
                    value={otp || ""}
                    {...sharedProps}
                    className="form-control"
                    placeholder="Enter OTP"
                  />
                </div>
                <div className="otpBtn">
                  <Button
                    color="primary"
                    className="addAction-btn"
                    onClick={handleVerifyOTP}
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinner size="sm" /> : "Sign In"}
                  </Button>
                </div>
              </>
            )}
          </Col>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
